import React, {useContext} from "react"

export const ScenarioTypeContext = React.createContext({
    scenarioType: undefined,
    uniqueIDs: undefined,
    uniqueLabels: undefined,
    intvs: {
        add: undefined,
        update: undefined,
        remove: undefined,
        getSorted: undefined
    },
    intvPrompts: {
        add: undefined,
        update: undefined,
        remove: undefined
    },
    intvPromptAnswers: {
        add: undefined,
        update: undefined,
        remove: undefined
    },
    intvMenuCategories: {
        add: undefined,
        update: undefined,
        remove: undefined,
        reorder: undefined
    },
    intvMenuItems: {
        add: undefined,
        update: undefined,
        remove: undefined
    },
    saveCheckList: undefined,
    saveMedications: undefined,
    saveInterventions: undefined
})

export const useScenarioType = () => useContext(ScenarioTypeContext)
